import { css } from 'styled-components';

export const buttonMixin = css`
background-color: orange;
border: none;
border-radius: 5px;
color: white;
transition: background-color 0.3s ease;
font-size: 16px;
font-weight: 400;
`;